import moment from 'moment';

import { TDateFilter, TFilters } from '../../types';

export const valueNormalizer = (
  value: string | number,
  custom?: Omit<TDateFilter, 'selectedDate'>,
  future?: boolean,
) => {
  if (value === 'any') {
    return {
      fromDate: moment().valueOf(),
      toDate: moment().valueOf(),
      selectedDate: value,
    };
  }
  if (value === 'today') {
    return {
      fromDate: moment()
        .startOf('day')
        .valueOf(),
      toDate: moment()
        .endOf('day')
        .valueOf(),
      selectedDate: value,
    };
  }
  if (value === 'tomorrow') {
    return {
      fromDate: moment()
        .add(1, 'day')
        .startOf('day')
        .valueOf(),
      toDate: moment()
        .add(1, 'day')
        .endOf('day')
        .valueOf(),
      selectedDate: value,
    };
  }
  if (value === 'yesterday') {
    return {
      fromDate: moment()
        .subtract(1, 'day')
        .startOf('day')
        .valueOf(),
      toDate: moment()
        .subtract(1, 'day')
        .endOf('day')
        .valueOf(),
      selectedDate: value,
    };
  }
  if (value === 'nextWeek') {
    return {
      fromDate: moment()
        .startOf('day')
        .valueOf(),
      toDate: moment()
        .add(6, 'day')
        .endOf('day')
        .valueOf(),
      selectedDate: value,
    };
  }
  if (value === 'custom' && custom) {
    return {
      ...custom,
      selectedDate: value,
    };
  }

  const getIntFromValue = (key: string | number) => {
    switch (key) {
      case 'pastWeek':
        return 7;
      case 'pastMonth':
        return 30;
      case 'pastYear':
        return 365;
      default:
        return 0;
    }
  };

  if (future) {
    return {
      fromDate: moment()
        .startOf('day')
        .valueOf(),
      toDate: moment()
        .add(getIntFromValue(value), 'day')
        .endOf('day')
        .valueOf(),
      selectedDate: value,
    };
  }

  return {
    fromDate: moment()
      .subtract(getIntFromValue(value), 'day')
      .startOf('day')
      .valueOf(),
    toDate: moment()
      .endOf('day')
      .valueOf(),
    selectedDate: value,
  };
};

// Make any named date filter, like 'Last 7 days' relative to the date and time the user is accessing the filter
export const getNormalizedDate = (remoteFilters: TFilters) => {
  if (remoteFilters && remoteFilters.dateRange) {
    const tempDateFilter = valueNormalizer(remoteFilters.dateRange.selectedDate, {
      fromDate: remoteFilters.dateRange.fromDate,
      toDate: remoteFilters.dateRange.toDate,
    });
    return { ...remoteFilters, dateRange: tempDateFilter };
  }
  return remoteFilters;
};
